/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Show_On_MapInputs */

const cs_property_show_on_map = /** @type {(inputs: Property_Show_On_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit na mapě`)
};

const en_property_show_on_map = /** @type {(inputs: Property_Show_On_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show on map`)
};

/**
* | output |
* | --- |
* | "Show on map" |
*
* @param {Property_Show_On_MapInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_show_on_map = /** @type {((inputs?: Property_Show_On_MapInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Show_On_MapInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_show_on_map(inputs)
	return cs_property_show_on_map(inputs)
});